// extracted by mini-css-extract-plugin
export default {"purpleHathor":"#8C46FF"};